import { useState } from "react";
import CodingLab from "../labs/CodingLab";
import CtfIntro from "../labs/CtfIntro";
import NetworkLab from "../labs/NetworkLab";

export default function Lab() {
  const [activeLab, setActiveLab] = useState("coding");

  return (
    <div className="flex h-screen bg-slate-950 text-gray-200">
      {/* SIDEBAR */}
      <div className="w-64 bg-slate-900 border-r border-gray-800 p-4">
        <h2 className="text-lg font-bold mb-6">🧪 Labs</h2>

        <Item label="💻 Coding Lab" active={activeLab==="coding"} onClick={()=>setActiveLab("coding")} />
        <Item label="🚩 CTF Lab" active={activeLab==="ctf"} onClick={()=>setActiveLab("ctf")} />
        <Item label="🌐 Network Lab" active={activeLab==="network"} onClick={()=>setActiveLab("network")} />
      </div>

      {/* CONTENT */}
      <div className="flex-1 p-8 overflow-y-auto">
        {activeLab === "coding" && <CodingLab />}
        {activeLab === "ctf" && <CtfIntro />}
        {activeLab === "network" && <NetworkLab />}
      </div>
    </div>
  );
}

function Item({ label, active, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`cursor-pointer px-4 py-3 rounded-lg mb-2 transition
        ${active ? "bg-blue-600/20 text-blue-400" : "hover:bg-slate-800"}
      `}
    >
      {label}
    </div>
  );
}
